import { Flex, FormControls } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';
import TrainingPeriodInfoTooltip from 'shared/components/TrainingPeriodInfoTooltip';
import { validateTrainingPeriodCount } from 'shared/utils/validators';
import { trainingPeriodOptions } from 'shared/constants';
import PeriodCountField from './PeriodCountField';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
};

const WizardTrainingPeriodSection = ({ methods }: Props) => (
  <FormControls.FieldsWrapper style={{ gap: '8px' }}>
    <Flex sx={{ alignItems: 'center', gap: '4px' }}>
      <FormControls.FormTitle>Training period</FormControls.FormTitle>
      <TrainingPeriodInfoTooltip />
    </Flex>
    <PeriodCountField
      methods={methods}
      prefix="Base the model on the previous"
      countName="anomalyConfig.trainingPeriod.count"
      unitName="anomalyConfig.trainingPeriod.period"
      unitOptions={trainingPeriodOptions}
      validate={(values) =>
        validateTrainingPeriodCount(
          values.anomalyConfig?.trainingPeriod?.count,
          values.anomalyConfig?.trainingPeriod?.period,
        )
      }
    />
  </FormControls.FieldsWrapper>
);

export default WizardTrainingPeriodSection;
